module.exports = __webpack_public_path__ + "static/img/img-p1.b7a62897.jpg";